import { render, staticRenderFns } from "./DoctorApkUpload.vue?vue&type=template&id=457759a2&scoped=true"
import script from "./DoctorApkUpload.vue?vue&type=script&lang=js"
export * from "./DoctorApkUpload.vue?vue&type=script&lang=js"
import style0 from "./DoctorApkUpload.vue?vue&type=style&index=0&id=457759a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457759a2",
  null
  
)

export default component.exports